export const COLLECTIONS = {
    users: "users",
    bookings: "bookings",
    bookingManifests: "bookingManifests",
    visionPointConfigs: "visionPointConfigs",
    transactions: "transactions",
    queue: "queue",
    checkins: "checkins",
    mailOrders: "mailOrders",
    goldPrices: "goldPrices",
    goldPriceAlerts: "goldPriceAlerts",
    /**
     * Cross-cutting audit log — every user-driven action and every system
     * event (SMS sent, email failed, scrape skipped, etc.) lands here so
     * admins can answer "when and why did X happen" for any entity.
     */
    actionLog: "actionLog",
    /**
     * Per-message archive of every transactional email we've sent. Captures
     * SendGrid's x-message-id (and any other response metadata) so we can
     * correlate later — even before any inbound webhook is wired up.
     */
    emailLog: "emailLog",
    imageAnalyses: "imageAnalyses",
    config: "config",
    reports: "reports",
    rateLimits: "rateLimits",
    invites: "invites",
    /** Raffineringsrunder: paid gold handed to KA Rasmussen, one open round at a time. */
    refiningRounds: "refiningRounds",
};
export const CONFIG_DOCS = {
    goldPriceJob: "goldPriceJob",
    /** The Finago integration's per-environment ids (`FinagoConfig`). */
    finago: "finago",
};
